import React from "react";
import Heading from "../ui/Heading";
import Slider from "react-slick";
import { Container, Image } from "react-bootstrap";
import { Link } from "react-router-dom/cjs/react-router-dom";
import left from "../../../../../Assets/images/left-setting.png";
import right from "../../../../../Assets/images/right-setting.png";
import solitaire from "../../../../../Assets/images/ring-style/solitaire.png";
import vintage from "../../../../../Assets/images/ring-style/vintage.png";
import channel from "../../../../../Assets/images/ring-style/channel-set.png";
import stackable from "../../../../../Assets/images/ring-style/stackable.png";
import sidestone from "../../../../../Assets/images/ring-style/sidestone.png";
import aniversary from "../../../../../Assets/images/ring-style/aniversary.png";
import bezel from "../../../../../Assets/images/ring-style/bezel.png";
import channelSet from "../../../../../Assets/images/ring-style/channel-set.png";
import curved from "../../../../../Assets/images/ring-style/curved.png";
import eternity from "../../../../../Assets/images/ring-style/eternity.png";
import halo from "../../../../../Assets/images/ring-style/halo.png"



const ShopRingByStyle = () => {
  
  const ringStyles = [
    { name: "Solitaire", image: solitaire, url: "ringsettings/style=Solitaire" },
    { name: "Vintage", image: vintage, url: "/ringsettings/style=Vintage" },
    // { name: "Channel Set", image: channel, url: "/jewelry/wedding-rings/style=Channel Set" },
    { name: "Stackable", image: stackable, url: "/jewelry/wedding-rings/style=Stackable" },
    { name: "Three Stone", image: sidestone, url: "/ringsettings/style=Three stone", },
    { name: "Halo", image: halo, url: "/ringsettings/style=Halo", },
    { name: "Anniversary", image: aniversary, url: "/jewelry/wedding-rings/style=Anniversary", },
      { name: "Eternity", image: eternity, url: "/jewelry/wedding-rings/style=Eternity", },

  ];

  // let settings2 = {
  //   dots: false,
  //   infinite: true,
  //   speed: 500,
  //   accessibility: true,
  //   arrows: true,
  //   slidesToShow: 5,
  //   slidesToScroll: 1,
  //   autoplay: false,
  //   prevArrow: <Image src={left} alt="arrow" />,
  //   nextArrow: <Image src={right} alt="arrow" />,
  //   responsive: [
  //     {  breakpoint: 1024, settings: {slidesToShow: 3, arrows: false, dots: true}},
  //     {  breakpoint: 768, settings: {slidesToShow: 2, arrows: false, dots: true}},
  //   ],
  //   beforeChange: (current, next) => {
  //     document
  //       .querySelectorAll('.slick-slide[aria-hidden="true"] a, .slick-slide[aria-hidden="true"] button, .slick-slide[aria-hidden="true"] input')
  //       .forEach(el => el.setAttribute('tabindex', '-1'));
  //   },
  //   afterChange: () => {
  //     document
  //       .querySelectorAll('.slick-slide:not([aria-hidden="true"]) a, .slick-slide:not([aria-hidden="true"]) button, .slick-slide:not([aria-hidden="true"]) input')
  //       .forEach(el => el.removeAttribute('tabindex'));
  //   }
  // };
  const settings2 = {
  centerMode: true,
  centerPadding: "40px",
  slidesToShow: 5,
  slidesToScroll: 1,
  infinite: true,
  speed: 500,
  dots: false,
  arrows: true,
  prevArrow: <Image src={left} alt="arrow" />,
    nextArrow: <Image src={right} alt="arrow" />,
      responsive: [
      {  breakpoint: 1024, settings: {slidesToShow: 3, arrows: true,}},
      {  breakpoint: 991, settings: {slidesToShow: 3, arrows: true,}},
        {  breakpoint: 767, settings: {slidesToShow: 1, arrows: true, centerMode: false,}},
    ],
};

  return (
    <section className="shop-ring-by-style section-space">
      <Container fluid className="showcase-container">
        <Heading className="text-center">
          <h2>Shop By Settings</h2>
         <p>Shop rings by setting and find your perfect match.</p>
        </Heading>
 <div className="center-slider">
        <Slider {...settings2}>
        {ringStyles.map((ring, index) => (
            <div className="item" key={index}> 
              <Link to={ring.url}>
                <Image src={ring.image} alt={`${ring.name} Ring`} style={{ margin: "auto", width: "90%", height: "auto" }} />
              </Link>
              <Link to={ring.url} className="ring_name_Style">
                {ring.name}
              </Link>  
            </div>
          ))}
        </Slider>
        </div>
      </Container>
    </section>
  );
};

export default ShopRingByStyle;
